const getImageClickActionConfig = ({
  imageData,
  config,
  expand
}) => {
  if (imageData?.link?.url && config) {
    return { type: "link" };
  }
  if (imageData?.link?.anchor) {
    return { type: "anchor" };
  }
  if (expand) {
    return { type: "expand", onClick: expand };
  }
  return { type: "regular" };
};
export {
  getImageClickActionConfig
};
//# sourceMappingURL=get-image-click-action-config.js.map
